<template>
  <div class="flex flex-nowrap place-items-start">
    <div class="w-full">
      <nav>
        <div class="flex flex-row gap-4 items-center">
          <div
            class="menu"
            :class="{
              active: !decodeURI($page.url).includes('type='),
            }"
          >
            <Link :href="route('admin.delivery') + changeType(null)"
              >未揀貨</Link
            >
          </div>
          <div
            class="menu"
            :class="{ active: decodeURI($page.url).includes('type=picking') }"
          >
            <Link :href="route('admin.delivery') + changeType('picking')"
              >備貨中</Link
            >
          </div>
          <div
            class="menu"
            :class="{
              active: decodeURI($page.url).includes('type=packing'),
            }"
          >
            <Link :href="route('admin.delivery') + changeType('packing')"
              >備貨完成</Link
            >
          </div>
        </div>
      </nav>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    //
  },
  props: {
    title: {
      type: String,
      default: "功能選單",
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      showTopMenu: false,
    };
  },
  computed: {
    side_menu_type() {
      if (this.windowWidth >= 640) return "side";
      return "dropdown";
    },
  },
  methods: {
    toggleTopMenu() {
      this.showTopMenu = !this.showTopMenu;
    },
    getQueryStrings() {
      let queryStr = window.location.search,
        queryArr = queryStr.replace("?", "").split("&"),
        queryParams = [];

      for (let q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
        let qArr = queryArr[q].split("=");
        queryParams[qArr[0]] = qArr[1];
      }

      return _(queryParams).omitBy(_.isUndefined).omitBy(_.isNull).value();
    },
    changeType(type) {
      let queryStringArray = this.getQueryStrings();

      if (type != null) {
        queryStringArray["type"] = type;
      } else {
        _.unset(queryStringArray, "type");
      }

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      return "?" + queryStrings.join("&");
    },
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
};
</script>

<style lang="postcss">
.top_menu_root {
  @apply w-full px-4 py-2 bg-fh-blue text-white;
}

.side_menu_root {
  @apply px-4 py-2 bg-fh-blue text-white;
}

.side_menu li {
  @apply px-4 py-2 border-t border-fh-gray-border;
}

.side_menu_active {
  @apply bg-fh-gray-bg;
}

.side_menu_inactive {
  @apply bg-fh-gray-bg;
}

.side_menu_inactive:hover {
  @apply bg-fh-gray-light;
}

.active {
  @apply border-b;
}

header {
  @apply text-2xl mt-1 mb-4;
}

nav {
  @apply text-lg mt-1 mb-4;
}

.form {
  @apply w-full mt-1 pt-3 flex flex-row justify-start items-center;
}

.form-title {
  @apply mt-1 w-32;
}

.form-element {
  @apply mt-1 flex flex-row items-center content-start gap-4;
}

.form-element-subs {
  @apply mt-1 flex flex-col content-start gap-1;
}

.form-element-sub {
  @apply mt-1 flex flex-row items-center gap-1;
}

.error_information {
  @apply text-red mt-1 ml-2;
}
</style>
